import { FC } from 'react';
import { Avatar } from 'antd';
import { AvatarSize } from 'antd/lib/avatar/SizeContext';
import { WhatsupIconColor } from '@/public/icons/messengers/WhatsupIconColor';
import { LineIconColor } from '@/public/icons/messengers/LineIconColor';
import { MsgIcon } from '@/public/icons/messengers/MsgIcon';
import { FBmsgIcon } from '@/public/icons/messengers/FBmsgIcon';
import { EmailIcon } from '@/public/icons/messengers/EmailIcon';
import { LineIcon } from '@/public/icons/messengers/LineIcon';
import { LiveChatIcon } from '@/public/icons/messengers/LiveChatIcon';
import './UserAvatar.scss';

type Props = {
  size?: AvatarSize;
  avatar: string;
  firstName: string;
  lastName: string;
  status?: string;
  className?: string;
};

const msgConfig = {
  Facebook: <FBmsgIcon />,
  SMS: <MsgIcon />,
  LineSocialMedia: <LineIconColor />,
  WhatsApp: <WhatsupIconColor />,
  Outlook: <EmailIcon />,
  Line: <LineIcon />,
  Copilot: <LiveChatIcon />,
};

const formAvatarLetters = (firstName: string, lastName: string) => {
  return `${firstName?.charAt(0)?.toUpperCase()} ${lastName?.charAt(0)?.toUpperCase()}`;
};

export const UserAvatar: FC<Props> = ({
  avatar,
  firstName,
  lastName,
  className,
  size = 36,
}) => {
  const userName =
    avatar && avatar !== ''
      ? msgConfig[avatar as keyof typeof msgConfig]
      : formAvatarLetters(firstName, lastName);

  return (
    <Avatar className={className} size={size}>
      {userName}
    </Avatar>
  );
};
